export default "__VITE_ASSET__aWbVNRoL__"